import { useBusinessContext } from '@root/context'
import { usePaymentMethodSetup } from '@root/query/hooks'

export const useUnpaidPlanStatus = () => {
  const { slug, data: business } = useBusinessContext()
  const hasUnpaidStatus = business?.billing_lock_reason === 'stripe_unpaid'
  const { startPaymentMethodSetup, isStartingPaymentMethodSetup } = usePaymentMethodSetup({
    slug
  })

  return {
    hasUnpaidStatus,
    startPaymentMethodSetup,
    isStartingPaymentMethodSetup
  }
}
